import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import "../profileSection.scss";
import {Button} from "@mui/material";
import {update} from "../../../actions/users";
import {useNavigate} from "react-router-dom";
import {RootState} from "../../../reducers/store";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import {UseGetUserInfo} from "../../../api/useUser";
import {setUserValue} from "../../../reducers/userReducer";

const ProfileSectionDataForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userIdStore = useSelector((state: RootState) => state.user.id);

    const isAuthStore = useSelector((state: RootState) => state.user.isAuth);
    const nameStore = useSelector((state: RootState) => state.user.name);
    const emailStore = useSelector((state: RootState) => state.user.email);
    const phoneStore = useSelector((state: RootState) => state.user.phoneNr);

    const [name, setName] = useState<string>(nameStore);
    const [email, setEmail] = useState<string>(emailStore);
    const [phone, setPhone] = useState<any>(phoneStore);
    const [password, setPassword] = useState<string>("");
    const [togglePassword, setTogglePassword] = useState<boolean>(false);
    const [changePassword, setChangePassword] = useState<boolean>(false);

    useEffect(() => {
        if (isAuthStore && userIdStore) {
            if (nameStore && emailStore && phoneStore) {
                setName(nameStore);
                setEmail(emailStore);
                setPhone(phoneStore);
            } else {
                UseGetUserInfo(userIdStore).then((response: any) => {
                    if (response && response.status === 200) {
                        setName(nameStore);
                        setEmail(emailStore);
                        setPhone(phoneStore);
                    }
                    else {
                        setName(nameStore);
                        setEmail(emailStore);
                        setPhone(phoneStore);
                    }
                })
            }
        }
    }, [isAuthStore]);
    
    const handleTogglePassword = () => {
        setTogglePassword(!togglePassword);
    }

    const handleButtonFormChangeSubmit = async () => {
        if (name && email && phone && password) {
            try {
                const user = JSON.parse(sessionStorage.getItem('user') as any);
                if (user) {
                    const response = await update(dispatch, name, email, phone, password);
                    if (response) {
                        alert("successfully update");
                    }
                    else {
                        alert("Password is incorrect");
                    }
                    /*const response = await fetch(`http://localhost:5000/api/auth/update/${user._id}`, {
                        method: "PUT",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            name,
                            email,
                            phone,
                            password
                        })
                    });
                    const content = await response.json();
                    console.log("update content: ", content);
                    if (content) {
                        alert("successfully update");
                    }*/
                }
            } catch (e) {
                console.log("error e: ", e);
            }
        } else {
            alert("Please fill in all fields");
        }
    }

    const handleChangePassword = () => {
        if (password) {
            setChangePassword(true);
            navigate("/profile/change-password");
            return true;
        }
        else if (password === '') {
            alert("Password field does not empty");
        }
        else {
            alert("Password is incorrect");
        }
        return false;
    }

    useEffect(() => {
        /*const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        if (user) {
            setName(user.name);
            setEmail(user.email);
            setPhone(user.phone);
        }*/
    }, []);

    return (
        <div className="profileSectionDataForm__container">
            <div className="profileSectionDataForm__container_content">
                <form className="profileSectionDataForm__container_content_form">
                    <div className="profileSectionDataForm__container_content_form_input_wrap name">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="profileSectionDataForm__container_content_form_input_wrap email">
                        <label htmlFor="email">E-mail</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="profileSectionDataForm__container_content_form_input_wrap phone">
                        <label htmlFor="phone">Phone number</label>
                        <PhoneInput
                          placeholder="Enter phone number"
                          value={phone}
                          onChange={setPhone}
                        />
{/*                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            required
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />*/}
                    </div>

                    <div className="profileSectionDataForm__container_content_form_input_wrap password">
                        <label htmlFor="password">Password</label>
                        <div className="profileSectionDataForm__container_content_form_input_wrap_password">
                            <input
                                type={`${togglePassword ? 'text' : 'password'}`}
                                id="password"
                                name="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div className="profileSectionDataForm__container_content_form_input_wrap_password_toggle">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/eye-${togglePassword ? 'open' : 'close'}.svg`}
                                    alt="eye"
                                    onClick={handleTogglePassword}
                                />
                            </div>
                            <div className="profileSectionDataForm__container_content_form_change_password_wrap">
                                <span
                                    className={`profileSectionDataForm__container_content_form_change_password`}
                                    onClick={handleChangePassword}
                                >
                                    Change password
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div className="profileSectionDataForm__container-button-btn_wrap">
                    <Button
                        className="profileSectionDataForm__container-button-btn save"
                        variant="contained"
                        onClick={handleButtonFormChangeSubmit}
                        disabled={!(name && email && phone && password)}
                    >
                            <span>
                                save
                            </span>
                    </Button>
                </div>

            </div>
        </div>
    );
}

export default ProfileSectionDataForm;